import React from "react";
import { Link } from "react-router-dom";
import { useBrands } from "@/context/BrandContext";
import { ArrowRight } from "lucide-react";

export default function BrandSelector() {
  const { brands, loading } = useBrands();

  return (
    <div className="min-h-screen bg-[#1a1612] text-white relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-20"
        style={{ backgroundImage: "radial-gradient(circle at 20% 10%, #C85A32 0%, transparent 40%), radial-gradient(circle at 80% 80%, #0E5A3A 0%, transparent 40%)" }}
      />

      <header className="relative z-10 px-6 lg:px-12 py-8 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <img
            src="/brand-logos/bigbillion.jpg"
            alt="Big Billion Food and Beverages Pvt Ltd"
            data-testid="parent-logo"
            className="h-12 lg:h-14 w-auto object-contain rounded-lg"
          />
        </div>
        <Link to="/admin-login" data-testid="admin-login-link" className="text-xs text-white/60 hover:text-white tracking-widest uppercase">Admin login</Link>
      </header>

      <main className="relative z-10 max-w-6xl mx-auto px-6 lg:px-12 pt-8 pb-16">
        {loading ? (
          <div className="grid md:grid-cols-2 gap-6 mt-8">
            {[0, 1].map((i) => (
              <div key={i} className="h-96 rounded-2xl bg-white/5 animate-pulse" />
            ))}
          </div>
        ) : (
          <div className="grid md:grid-cols-2 gap-6 mt-8">
            {brands.map((b, i) => (
              <Link
                key={b.key}
                to={`/b/${b.key}`}
                data-testid={`brand-card-${b.key}`}
                className="group relative rounded-2xl overflow-hidden border border-white/10 fade-up"
                style={{
                  animationDelay: `${i * 120}ms`,
                  background: `linear-gradient(135deg, ${b.primary}22, ${b.secondary}44)`,
                }}
              >
                <div
                  className="absolute inset-0 transition-opacity duration-500 opacity-30 group-hover:opacity-60"
                  style={{ background: `radial-gradient(circle at 70% 30%, ${b.accent}55, transparent 60%)` }}
                />
                <div className="relative p-10 lg:p-14 min-h-[360px] flex flex-col justify-between">
                  <div className="flex items-center justify-center pt-6 pb-2">
                    <div className="inline-flex items-center justify-center rounded-2xl px-6 py-5 shadow-lg"
                      style={{ background: b.logo_bg || "#FFFFFF" }}>
                      <img
                        src={b.logo_url}
                        alt={`${b.name} logo`}
                        data-testid={`brand-logo-img-${b.key}`}
                        className="h-24 lg:h-32 w-auto object-contain"
                      />
                    </div>
                  </div>
                  <div className="flex items-center justify-between mt-8">
                    <span className="overline text-white/50">Enter storefront</span>
                    <div
                      className="w-12 h-12 rounded-full flex items-center justify-center transition-transform duration-300 group-hover:translate-x-1"
                      style={{ background: b.accent, color: "#1a1612" }}
                    >
                      <ArrowRight className="w-5 h-5" />
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}

        <p className="text-center text-white/40 text-sm mt-16">
          A Big Billion Food and Beverages Private Limited venture
        </p>
      </main>
    </div>
  );
}
